import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/core/ui/Button'
import LPContainer from '../LandingPage/LPContainer'
import Link from 'next/link'
import { CONTACT_REQUEST_URL } from '~/core/constants/url'

const CTASection: FC = () => {
  const { t, i18n } = useTranslation()

  return (
    <div
      className="flex flex-col items-center py-16 mx-auto"
      style={{
        backgroundImage: `url('/img/feature/lp/bg-cta.svg')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover'
      }}>
      <LPContainer>
        <div className="mx-auto text-center">
          <h2 className="text-[31px] leading-[34px] tablet:text-[37px] tablet:leading-[42px] mb-4 font-semibold text-gray-900">
            {t('lp:talent_ai:cta:title')}
          </h2>
          <p className="text-[16px] leading-[24px] text-gray-700 mb-8 mx-auto">
            {t('lp:talent_ai:cta:description')}
          </p>
          <div className="flex justify-center">
            <Link
              href={CONTACT_REQUEST_URL}
              locale={i18n?.language}
              className="flex justify-center">
              <Button
                size="xl"
                label={`${t('lp:request_demo')}`}
                type="primary"
                className="bg-indigo-600 hover:bg-indigo-700 text-white border-0"
              />
            </Link>
          </div>
        </div>
      </LPContainer>
    </div>
  )
}

export default CTASection
